import React from 'react'
import PropTypes from 'prop-types'
import { useTestCampaignContext } from './testCampaignContext'
import AssetSelectionStep from './AssetSelectionStep'
import ProgressView from './ProgressView'
import SuccessView from './SuccessView'
import ErrorView from './ErrorView'
import Portal from 'components/Shared/Portal'
import Modal from 'components/Shared/Modal'

export default function TestCampaignModal({ assets }) {
  const { modalOpen, modalView, currentCampaign, closeModal, retry, clearSelection, error } =
    useTestCampaignContext()

  const handleClose = () => {
    closeModal()
  }

  const handleRunAnother = () => {
    clearSelection()
    retry()
  }

  const handleRetry = () => {
    retry()
  }

  const renderContent = () => {
    switch (modalView) {
      case 'selection':
        return <AssetSelectionStep assets={assets} onCancel={handleClose} error={error} />

      case 'progress':
        return currentCampaign ? (
          <ProgressView campaign={currentCampaign} onClose={handleClose} />
        ) : null

      case 'success':
        return currentCampaign ? (
          <SuccessView
            campaign={currentCampaign}
            onClose={handleClose}
            onRunAnother={handleRunAnother}
          />
        ) : null

      case 'error':
        return currentCampaign ? (
          <ErrorView campaign={currentCampaign} onClose={handleClose} onRetry={handleRetry} />
        ) : (
          <AssetSelectionStep assets={assets} onCancel={handleClose} error={error} />
        )

      default:
        return null
    }
  }

  return modalOpen ? (
    <Portal wrapperId="app-portal">
      <Modal
        isOpen={modalOpen}
        onClickOutside={handleClose}
        closeCallback={handleClose}
        offWhiteBg
        size="lg"
        fullWidth={false}
        mainContent={<div className="test-campaign-modal">{renderContent()}</div>}
      />
    </Portal>
  ) : null
}

TestCampaignModal.propTypes = {
  assets: PropTypes.array.isRequired,
}
